import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
      routes: [
            { path: '/', name: 'homePage', component: require(page + 'home/index.vue').default, meta: { title: "Extraordinary real estate in Costa Rica" }},
            { path: '/contact', name: 'contactPage', component: require(page + 'contact/index.vue').default, meta: { title: "Contact" }},
            { path: '/sell-with-us', name: 'sellWithUs', component: require(page + 'about/sell-with-us.vue').default, meta: { title: "Sell with us" }},
            { path: '/about-sothebys-costa-rica', name: 'aboutSothebys', component: require(page + 'about/about-sothebys.vue').default, meta: { title: "About Sotheby’s Costa Rica" }},
            { path: '/privacy-policy', name: 'privacyPolicy', component: require(page + 'text-pages/privacy-policy.vue').default, meta: { title: "Privacy Policy" }},
            { path: '/terms', name: 'terms', component: require(page + 'about/terms.vue').default, meta: { title: "Terms & Conditions" }},
            { path: '/agents', name: 'agentsPage', component: require(page + 'agents/index.vue').default, meta: { title: "Agents" }},
            { path: '/agents/:id', name: 'agentDetail', component: require(page + 'agents/detail.vue').default, meta: { title: "Agent" }},
            { path: '/destinations', name: 'destinationsPage', component: require(page + 'discover/destinations.vue').default, meta: { title: "Destinations" }},
            { path: '/destinations/:id', name: 'destinationDetail', component: require(page + 'properties/destinations.vue').default, meta: { title: "Destinations" }},
            { path: '/lifestyles', name: 'lifestylesPage', component: require(page + 'discover/lifestyles.vue').default, meta: { title: "Lifestyles" }},
            { path: '/lifestyles/:id', name: 'lifestyleDetail', component: require(page + 'properties/lifestyles.vue').default, meta: { title: "Lifestyles" }},
            { path: '/projects', name: 'projectsPage', component: require(page + 'discover/projects.vue').default, meta: { title: "Projects" }},
            { path: '/projects/:id', name: 'projectDetail', component: require(page + 'discover/project-detail.vue').default, meta: { title: "Project" }},
            { path: '/blog', name: 'blogPage', component: require(page + 'blog/index.vue').default, meta: { title: "Blog" }},
            { path: '/blog/:id', name: 'blogDetail', component: require(page + 'blog/detail.vue').default, meta: { title: "Blog" }},
            { path: '/properties', name: 'propsPage', component: require(page + 'properties/index.vue').default, meta: { title: "Properties List" }},
            { path: '/properties/sale', name: 'propsSalePage', component: require(page + 'properties/sale.vue').default, meta: { title: "Properties for sale" }},
            { path: '/properties/rent', name: 'propsRentPage', component: require(page + 'properties/rent.vue').default, meta: { title: "Properties for rent" }},
            { path: '/property/:id', name: 'propDetailPage', component: require(page + 'properties/detail.vue').default, meta:{title:"Property Detail",excludeFromGtag: true}},
            { path: '/office/:id', name: 'officeDetail', component: require(page + 'properties/office.vue').default, meta: { title: "Properties" }},
            { path: '/thankyou-page-contactus', name: 'thankYouContactUs', component: require(page + 'contact/thank-you.vue').default, meta: { title: "Contact home" }},
            { path: '/thankyou-page-propertydetail', name: 'thankYouPropertyDetail', component: require(page + 'contact/thank-you.vue').default, meta: { title: "Contact Property" }},
            { path: '/thankyou-page-contactagent', name: 'thankYouContactAgent', component: require(page + 'contact/thank-you.vue').default, meta: { title: "Contact Agent" }},
            { path: '/thankyou-page-sellwithus', name: 'thankYouSellWithUs', component: require(page + 'contact/thank-you.vue').default, meta: { title: "Contact Sell with us" }},
            { path: '/thankyou-page-projects', name: 'thankYouProjects', component: require(page + 'contact/thank-you.vue').default, meta: { title: "Contact Projects" }},
            { path: '/thankyou-page-aboutus', name: 'thankYouAboutUs', component: require(page + 'contact/thank-you.vue').default, meta: { title: "Contact About us" }},
            { path: '/thankyou-page', name: 'thankYou', component: require(page + 'contact/thank-you.vue').default, meta: { title: "Contact" }},
        ],
        mode: 'history',
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}

 // Verifica si la ruta actual debe ser excluida
 if (to.meta.excludeFromGtag) {
      return; // No enviar esta ruta a gtag
    }
      if (Vue.$gtag) {
            Vue.$gtag.pageview({
              page_path: to.fullPath,
              page_title: to.meta.title || document.title, // Usa el meta.title aquí
            });
          
          } else {
          }

});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Costa Rica Sotheby’s International Realty", filter: (title)=>{ return title+" - Costa Rica Sotheby’s International Realty"; } }
);

// export {routes};
export default MyRouter;
